export default {
      id: "icon-filter-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-filter",
      toString: function () {
        return this.url;
      }
    }